import { motion } from 'framer-motion';
import { CREW } from './data';
// CREW — credits-roll style.
export default function Crew() {
  return (
    <div className="bg-[#0A0908] text-[#FBF6E8]">
      <section className="pt-32 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#FBF6E8]/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9963E] mb-4">— Index 03 / The crew</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em]">A small <span className="italic text-[#C9963E]">unit</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#FBF6E8]/65 mt-6 max-w-2xl">Three principals, fourteen freelancers, all known for at least seven years. We hire repeatedly. Below are three of us.</p>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-px bg-[#FBF6E8]/10">
        {CREW.map((c, i) => (
          <motion.div key={c.name} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-[#0A0908] p-8 group">
            <div className="aspect-[4/5] overflow-hidden bg-[#1A1A18] mb-6"><img src={c.img} alt={c.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000" loading="lazy" /></div>
            <p className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#C9963E]">{c.role}</p>
            <p className="font-serif text-3xl mt-2">{c.name}</p>
            <p className="font-mono text-[11px] text-[#FBF6E8]/55 mt-2">{c.cred}</p>
          </motion.div>
        ))}
      </section>

      {/* End-credits roll style */}
      <section className="bg-[#06060A] py-20 border-t border-[#FBF6E8]/10">
        <div className="max-w-[820px] mx-auto px-6 lg:px-12">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9963E] mb-8 text-center">— FREQUENT COLLABORATORS</p>
          <table className="w-full font-mono text-[12px]">
            <tbody>
              {[
                ['1st AC', 'Marta Lindgren · 14 films'], ['Gaffer', 'Pedro Salazar · 22 films'], ['Sound', 'Mira Olesson · 18 films'],
                ['Editor', 'Yann Berthelot · 27 films'], ['Composer', 'Olin Marsh · 9 films'], ['Colorist', 'Eli Castaneda · 31 films'],
              ].map(([role, cred]) => (
                <tr key={role} className="border-b border-[#FBF6E8]/10"><td className="py-3 text-[#FBF6E8]/45 tracking-[0.2em] uppercase w-32">{role}</td><td className="py-3 text-[#FBF6E8]/85">{cred}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
